/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedStarterPacks.defs.js'
export * as $defs from './getSuggestedStarterPacks.defs.js'
